// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-message {
  width: 100%;
  max-width: 500px;
  margin-bottom: 20px;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.error-content {
  background: #fff3cd;
  border: 2px solid #ffc107;
  border-radius: 8px;
  padding: 15px 20px;
  display: flex;
  align-items: flex-start;
  gap: 15px;
  box-shadow: 0 4px 12px rgba(255, 193, 7, 0.2);
}

.error-icon {
  font-size: 24px;
  flex-shrink: 0;
}

.error-text {
  flex: 1 1;
}

.error-text strong {
  display: block;
  color: #856404;
  font-size: 16px;
  margin-bottom: 5px;
}

.error-text p {
  color: #856404;
  font-size: 14px;
  margin: 0;
}

.error-close {
  background: none;
  border: none;
  font-size: 24px;
  color: #856404;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  transition: color 0.2s ease;
}

.error-close:hover {
  color: #d32f2f;
}
`, "",{"version":3,"sources":["webpack://./src/components/ErrorMessage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".error-message {\n  width: 100%;\n  max-width: 500px;\n  margin-bottom: 20px;\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.error-content {\n  background: #fff3cd;\n  border: 2px solid #ffc107;\n  border-radius: 8px;\n  padding: 15px 20px;\n  display: flex;\n  align-items: flex-start;\n  gap: 15px;\n  box-shadow: 0 4px 12px rgba(255, 193, 7, 0.2);\n}\n\n.error-icon {\n  font-size: 24px;\n  flex-shrink: 0;\n}\n\n.error-text {\n  flex: 1;\n}\n\n.error-text strong {\n  display: block;\n  color: #856404;\n  font-size: 16px;\n  margin-bottom: 5px;\n}\n\n.error-text p {\n  color: #856404;\n  font-size: 14px;\n  margin: 0;\n}\n\n.error-close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #856404;\n  cursor: pointer;\n  padding: 0;\n  flex-shrink: 0;\n  transition: color 0.2s ease;\n}\n\n.error-close:hover {\n  color: #d32f2f;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
